import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ParcellaGiudiziale } from 'src/app/common/models/parcella-giudiziale';
import { ParcellaSoggetto } from 'src/app/common/models/parcella-soggetto';
import { ParcellaStragiudiziale } from 'src/app/common/models/parcella-stragiudiziale';
import { SezioneParcelleGiudiziali } from 'src/app/common/models/sezioni/sezione-parcelle-giudiziali';
import { SezioneParcelleStragiudiziali } from 'src/app/common/models/sezioni/sezione-parcelle-stragiudiziali';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { ParcelleRipartizioneComponent } from './parcella-ripartizione.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [parcella-mod-ripartizione]',
  templateUrl: 'parcella-mod-ripartizione.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ParcellaModRipartizione {
  @Output() onReturn: EventEmitter<SezioneParcelleGiudiziali | SezioneParcelleStragiudiziali> = new EventEmitter<SezioneParcelleGiudiziali | SezioneParcelleStragiudiziali>();
  @ViewChild('formParcellaRipartizione') formParcellaRipartizione: ParcelleRipartizioneComponent;

  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();

  inizializza(sezione: SezioneParcelleGiudiziali | SezioneParcelleStragiudiziali, parcella: ParcellaGiudiziale | ParcellaStragiudiziale, urlUpdate: string, fascicolo: FascicoloFull, inserimento: boolean, ripartizione?: ParcellaSoggetto, title?: string) {
   this.formParcellaRipartizione.inizializza(sezione, parcella, urlUpdate, fascicolo, inserimento, ripartizione, title);
    openModal('modalRipartizioneParcella');
  }

  createForm() {
    this.formParcellaRipartizione.createForm();
  }

  manageModal(sezione: SezioneParcelleGiudiziali | SezioneParcelleStragiudiziali) {
      closeModal('modalRipartizioneParcella');
      this.onReturn.emit(sezione);
  }
}
